import React from 'react';
import Hero from '../components/UI/Hero';
import Button from '../components/UI/Button';
import { products } from '../data/products';
import heroImage from '../assets/optimized/asset4.webp';
import './ProductsPage.css';

const ProductsPage = () => {
  return (
    <div className="products-page">
      <Hero
        image={heroImage}
        title="Our Products"
        subtitle="Free software tools designed to enhance your productivity."
        size="medium"
      />

      <section className="products-list-section">
        <div className="container">
          {products.map((product) => (
            <div key={product.id} className="product-card-large">
              <div className="product-card-left">
                <div className="product-card-image">
                  <img src={product.listImage || product.image} alt={product.name} />
                </div>
                <div className="product-card-actions">
                  {product.playUrl && (
                    <Button href={product.playUrl} variant="primary" target="_blank">
                      Play Now
                    </Button>
                  )}
                  {product.siteUrl && (
                    <Button href={product.siteUrl} variant="primary" target="_blank">
                      Visit Website
                    </Button>
                  )}
                  {product.downloads && (
                    <>
                      <Button href={product.downloads.mac.url} variant="primary">
                        Download for Mac
                      </Button>
                      <Button href={product.downloads.windows.url} variant="outline-dark">
                        Download for Windows
                      </Button>
                    </>
                  )}
                </div>
              </div>
              <div className="product-card-content">
                <div className="product-card-header">
                  <span className={`product-badge ${product.status === 'in-development' || product.status === 'alpha' ? 'product-badge-wip' : ''}`}>
                    {product.status === 'in-development' ? 'In Development' :
                     product.status === 'alpha' ? 'Alpha' :
                     product.siteUrl ? 'Live Website' :
                     product.playUrl ? 'Play Free' : 'Free Download'}
                  </span>
                  <h2 className="product-card-title">{product.name}</h2>
                  <p className="product-card-tagline">{product.tagline}</p>
                </div>
                <p className="product-card-desc">{product.description}</p>
                <ul className="product-card-features">
                  {product.features.slice(0, 4).map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
                <Button to={`/products/${product.id}`} variant="link">
                  Learn more about {product.name}
                </Button>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="coming-soon-section">
        <div className="container text-center">
          <h2 className="section-title">More Products Coming Soon</h2>
          <p className="section-subtitle" style={{ margin: '0 auto 2rem' }}>
            We're always working on new tools and applications. Stay tuned for updates.
          </p>
          <Button to="/contact" variant="outline-dark">
            Get Notified
          </Button>
        </div>
      </section>
    </div>
  );
};

export default ProductsPage;
